import { Injectable } from '@angular/core';
import { TerminalModal } from 'src/app/pages/common/system/terminal/model/terminal.model';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class WeeklySalesService {

   constructor(private http: HttpClient) { }
      
        getweeklylList(requestData:RequestData): Observable<any> {
          return this.http.post(environment.baseUrl+'/shop/reports/get-weekly-sales', requestData);
      
        }

         downloadExcel(requestData: any): Observable<Blob> {
                const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
               // const url = 'http://yourdomain.com/api/customers/export'; // Adjust URL
            
                return this.http.post(environment.baseUrl + '/shop/reports/export-weekly-sales', requestData, { headers, responseType: 'blob' })
                  .pipe(
                    //catchError(this.handleError)
                  );
            
              }
}
